




























































import Vue, { PropType } from 'vue'
import Analytics from '@/services/Analytics'
import { mapGetters } from 'vuex'
import { debounce } from 'debounce'
import Person from '@/types/Person.interface'
import MessageTag from '@/types/MessageTag.interface'
export default Vue.extend({
    props: {
        disabled: {
            type: Boolean,
            default: false,
            required: false
        },
        icon: {
            type: Boolean,
            default: true
        },
        isInvoice: {
            type: Boolean,
            default: false
        },
        left: {
            type: Boolean,
            default: false
        },
        person: {
            type: Object as PropType<Person>,
            default: null
        },
        small: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            tag: '{{tag}}',

            // The tags to be displayed
            tags: null,

            //  Our tag folders
            tagCategories: null,

            // Determines if the main menu is shown
            mainMenuDisplay: false,

            //  Determines if we are currently searching
            searching: false
        }
    },
    mounted() {
        //  Give us the default tags and invoice tags if needed
        this.resetTags()
    },
    computed: {
        ...mapGetters(['hasInvoices', 'isSphere', 'messageTags'])
    },
    methods: {
        onTagSelected(tag: MessageTag): void {
            //  Report the actions to analytics
            Analytics.track('MessageTagSelected', { tag: tag })

            this.mainMenuDisplay = false

            this.$emit('onTagSelected', tag)
        },
        resetTags(): void {
            // If tags are still not loaded, return
            if (!this.messageTags) return

            // Init. the tags as empty arrays
            const tags = []
            const tagCategories = [
                {
                    type: 'person',
                    items: []
                },
                {
                    type: 'tenant',
                    items: []
                },
                {
                    type: 'user',
                    items: []
                },
                {
                    type: 'forms',
                    items: []
                },
                {
                    type: 'extensions',
                    items: []
                },
                {
                    type: 'invoice',
                    items: []
                }
            ]

            //  Our model map to make things easier for us
            const modelMap = {
                person: 0,
                tenant: 1,
                user: 2,
                forms: 3,
                extensions: 4,
                invoice: 5
            }

            for (const [tag, data] of Object.entries(this.messageTags)) {
                // If the tag is an invoice tag but invoice prop set to false, don't add tag
                if (!this.isInvoice && data['model'] == 'invoice') continue

                // If the tag is a sphere tag but sphere prop set to false, don't add tag
                if (!this.isSphere && data['filter'] == 'spherePaymentPage') continue

                //  Push our tag into our list
                tags.push(tag)

                //  Push this tag into extensions if type matches
                if (data['type'] === 'extension') tagCategories[0].items.push(tag)
                //  If this has forms in th ekey, this is a forms tag
                else if (data['key'].includes('forms')) tagCategories[3].items.push(tag)
                //  Else if we see tenant at all, push it
                else if (data['model'].includes('tenant'))
                    tagCategories[1].items.push(tag)
                //  Else, push it based on the model
                else {
                    //  Find our index
                    const idx = modelMap[data['model']]

                    //  Set our tag
                    tagCategories[idx].items.push(tag)
                }
            }

            //  Set our tags
            this.tags = tags
            //  Set our tag categories
            this.tagCategories = tagCategories
        },
        tagSearch: debounce(function (searchText: string): void {
            //  If search text is null then reset our tags
            if (!searchText) {
                //  Disable our search flag
                this.searching = false
                return this.resetTags()
            }

            //  Enable our search flag
            this.searching = true

            //  Find a tag matching this text string
            this.tags = this.tags.filter((x: string) =>
                x.toLowerCase().includes(searchText.toLowerCase())
            )
        }, 400),
        title(category: string): string {
            return (
                {
                    extensions: 'Custom Field Tags',
                    person: 'Contact Tags',
                    tenant: 'Organization Tags'
                }[category] || category.toProperCase() + ' Tags'
            )
        },
        toggleMainMenuDisplay(): void {
            // Toggle the menu
            this.mainMenuDisplay = !this.mainMenuDisplay
        }
    },
    watch: {
        isInvoice(): void {
            //  Reset the tags when the isInvoice prop changes
            this.resetTags()
        },
        messageTags(): void {
            this.resetTags()
        },
        person(val: Person) {
            if (val) {
                //  Give us the default tags and invoice tags if needed
                this.resetTags()
            }
        }
    }
})
